var render = function render(_c,_vm){return _c('div',{staticClass:"multi-select-entry"},[_c('svg',{staticClass:"multi-select-entry-check",attrs:{"width":"18","height":"18"}},[(_vm.props.checked)?_c('use',{attrs:{"xlink:href":require("./checkbox.svg") + "#checked"}}):_c('use',{attrs:{"xlink:href":require("./checkbox.svg") + "#unchecked"}})]),_c('span',[_vm._v(_vm._s(_vm.props.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }